import axios from 'axios';
import { Auth } from 'aws-amplify';
// import moment from 'moment';

export default {
    namespaced: true,

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    state: {
        //-----         system data         -----//
        url: 'https://bew9p5lz42.execute-api.us-west-2.amazonaws.com/production/sqlconnector',
        uploadPhotoURL: 'https://ia6e5n5uej.execute-api.us-west-2.amazonaws.com/production/upload-image-to-s3',
        user: [],
        session: [],
        processing: false,
        validLowerChars: 'abcdefghijklmnopqrstuvwxyz',
        validUpperChars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        invalidChars: "|[",

        //-----        purple tables        -----//
        diets: [],
        allergies: [],
        foodTypes: [],
        ingredientsToAvoidJunction: [],
        conversionChart: [],

        //-----      light green tables      -----//
        account: [],
        individual: [],
        accountAllergyJunctions: [],
        favoriteFoodTypeJunction: [],
        accountRecipeJunction: [],
        mealTime: [],
        
        //-----         blue tables         -----//
        recipe: [],
        recipeSource: [],
        recipeFoodTypeJunction: [],
        recipeIngredientJunction: [],
        ingredient: [],
        recipeStepDirections: [],
        dietRecipeJunction: [],

        //-----      dark green tables      -----//
        menu: [],
        menuRecipeMealTimeJunction: [],
        shoppingList: [],
        shoppingItem: [],

        //-----         signup data         -----//
        stepper: 1,
        mealsToPlan: null,
        people:[],
        suggestedCalories: null,
        credentials: [],
        SUdiet: null,
        SUallergies: [],
        SUlikes: [],
        newPerson: false,

        //-----       other variables       -----//
        navMenu: false, //used on app.vue to indicate if the nav menu should be expanded or not
        ingredientToAdd: null, //used for "add recipe" page to store the name of the selected ingredient user is adding
        ingredients: [], //used for "add recipe" or "edit recipe" page to store recipe ingredients
        directions: [], //used for "add recipe" or "edit recipe"  page to store directions to add
        createNewIngredientDialog: false, //indicates if a new ingredient is being created
        recipeName: null, //used for "add recipe" page to store name of new ercipe
        fileType: null, //used for "add recipe" to store the file type of the uploaded recipe image
        selectedRecipeID: null, //used for "recipes" page when selecting a recipe to open
        dataLoaded: null, //used to indicate when all of the above tables have been loaded into the vuex store
        dataLastRefreshed: null, //used in conjunction with loadData to track when data was last refreshed.
        windowHeight: 0, //used in app.vue to determine window height
        windowWidth: 0, //used in app.vue to determine window width
        addRecipeDialog: false, //used on recipes and add recipe pages to indicate when to show add recipe dialog
        rerender: 0, //increment to force re-render of recipes list
        recipeDialog: false, //indicate whether or not a recipe has been selected (specifically on recipes page)
        savedPreferences: true, //indicates whether or not food preference changes have been saved
        mealTimeToEdit: null, //tracks which meal time is being edited
        editMealDialog: false, //indicate whether or not the edit meal_time dialog is open
        editRecipe: false, //indicate whether or not the currently open recipe (selectedRecipeID) is being edited
        thisRecipeSource: null, //recipe source for recipe currently being added or edited
        photoCredit: null, //"photo by" for the recipe currently being added or edited
        difficulty: null, //difficulty for the recipe currently being added or edited
        prepTimeMin: null, //prep time (minutes) for the recipe currently being added or edited
        mealType: [], //meal uses for the recipe currently being added or edited
        leftoverType: [], //leftover uses for the recipe currently being added or edited
        foodType: [], //food category for the recipe currently being added or edited
        selectedRecipeImageURL: null, //stores the selected recipe's image URL
        thisRecipe: {}, //stores the data for the currently selected recipe (view or edit)
        directRecipeURL: null, //stores the direct link to an online recipe's source that is being added or edited
        audited: null, //indicates if the recipe or ingredient being edited has been audited or not
        adminView: false, //indicates if the user has opted for admin view or not (only available to select for admin users)
        
        //-----      new ingredient variables      -----//
        addIngredientDialog: false, //indicates if the add ingredient dialog should be open for adding ingredient to recipe
        selectedIngredientId: null, //ID of ingredient that has been selected for editing
        selectedIngredient: [], //entry for selected ingredient
        editIngredientDialog: false, //indicates if the edit ingredient dialog window should be open
        newIngredientName: null,
        newIngredientPlural: null,
        newIngredientUnitQuantity: null,
        storeSection: null,
        newIngredientUnit: null,
        newIngredientAllergy: [],
        nutrition: [
            {
                category: 'Total Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Saturated Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Trans Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Polyunsaturated Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Monounsaturated Fat',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Cholesterol',
                amount: null,
                unit: 'mg',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Sodium',
                amount: null,
                unit: 'mg',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Total Carbohydrate',
                amount: null,
                unit: 'g',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
            {
                category: 'Dietary Fiber',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Sugars',
                amount: null,
                unit: 'g',
                ml: 'ml-4',
                fontWeight: 'font-weight-regular'
            },
            {
                category: 'Protein',
                amount: null,
                unit: 'g',
                ml: 'ml-0',
                fontWeight: 'font-weight-bold'
            },
        ],
        deleteIngredientErrorMessage: null,
        deleteIngredientDialog: false,

    },

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    actions: {
//---------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- system data ----------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//
        updateUser({commit},value) {
            commit('updateUser',value);
        },

        session({commit},value) {
            commit('session',value)
        },

        updateProcessing({commit},value) {
            commit('updateProcessing',value);
        },

        loadSignUpData({commit}) {
            commit('loadDiets');
            commit('loadAllergies');
            commit('loadFoodTypes');
        },

        loadSignInData({state,commit},value) {
            //-----         system data         -----//
            commit('loadUser');

            //-----        purple tables        -----//
            if (state.diets.length == 0) {
                commit('loadDiets');
            }
            if (state.ingredientsToAvoidJunction.length == 0) {
                commit('loadIngredientsToAvoidJunctions',value);
            }
            if (state.allergies.length == 0) {
                commit('loadAllergies');
            }
            if (state.foodTypes.length == 0) {
                commit('loadFoodTypes');
            }
            if (state.conversionChart.length == 0) {
                commit('loadConversionChart');
            }
            //-----      light green tables      -----//
            if (state.account.id == null) {
                commit('loadAccount',value);
            }
            if (state.individual.length == 0) {
                commit('loadIndividuals',value);
            }
            if (state.accountAllergyJunctions.length == 0) {
                commit('loadAccountAllergyJunctions',value);
            }
            if (state.favoriteFoodTypeJunction.length == 0) {
                commit('loadFavoriteFoodTypeJunctions',value);
            }
            if (state.accountRecipeJunction.length == 0) {
                commit('loadAccountRecipeJunctions',value);
            }
            if (state.mealTime.length == 0) {
                commit('loadMealTimes',value);
            }
            
            //-----         blue tables         -----//
            if (state.recipe.length == 0) {
                commit('loadRecipes');
            }
            if (state.recipeSource.length == 0) {
                commit('loadRecipeSources');
            }
            if (state.recipeFoodTypeJunction.length == 0) {
                commit('loadRecipeFoodTypeJunctions');
            }
            if (state.recipeIngredientJunction.length == 0) {
                commit('loadRecipeIngredientJunctions');
            }
            if (state.ingredient.length == 0) {
                commit('loadIngredients');
            }
            if (state.recipeStepDirections.length == 0) {
                commit('loadRecipeStepDirections');
            }            
            if (state.dietRecipeJunction.length == 0) {
                commit('loadDietRecipeJunctions')
            }

            //-----      dark green tables      -----//
            if (state.menu.length == 0) {
                commit('loadMenus',value);
            }
            if (state.menuRecipeMealTimeJunction.length == 0) {
                commit('loadMenuRecipeMealTimeJunctions',value);
            }
            if (state.shoppingList.length == 0) {
                commit('loadShoppingLists',value);
            }
            if (state.shoppingItem.length == 0) {
                commit('loadShoppingItems',value);
            }
        },

        dataSignOut({commit,dispatch}) {
            //-----         system data         -----//
            commit('clearUser');
            commit('clearSession');

            //-----        purple tables        -----//
            commit('clearDiets');
            commit('clearAllergies');
            commit('clearFoodTypes');
            commit('clearIngredientsToAvoidJunction');
            commit('clearConversionChart');
            
            //-----      light green tables      -----//
            commit('clearAccount');
            commit('clearIndividual');
            commit('clearAccountAllergyJunctions');
            commit('clearFavoriteFoodTypeJunction');
            commit('clearAccountRecipeJunction');
            commit('clearMealTime');
            
            //-----         blue tables         -----//
            commit('clearRecipe');
            commit('clearRecipeSource');
            commit('clearRecipeFoodTypeJunction');
            commit('clearRecipeIngredientJunction');
            commit('clearIngredient');
            commit('clearRecipeStepDirections');
            commit('clearDietRecipeJunction');
            
            //-----      dark green tables      -----//
            commit('clearMenu');
            commit('clearMenuRecipeMealTimeJunction');
            commit('clearShoppingList');
            commit('clearShoppingItem');

            //-----         other data         -----//
            commit('updateNavMenu',false);
            dispatch('clearSignupData');
            commit('updateAdminView',false);
        },

//---------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- purple tables ---------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//
        //--------------------------------------------------//
        //-----           diet table actions           -----//
        //--------------------------------------------------//
        loadDiets({commit}){
            commit('loadDiets'); //loads list of diet options
        },

        updateDiets({commit},value) {
            commit('updateDiets',value)
        },

        //-------------------------------------------------//
        //-- ingredients_to_avoid_junction table actions --//
        //-------------------------------------------------//
        loadIngredientsToAvoidJunctions({commit}){
            commit('loadIngredientsToAvoidJunctions'); //loads list of ingredients to avoid
        },

        //-------------------------------------------------//
        //-----         allergy table actions         -----//
        //-------------------------------------------------//
        loadAllergies({commit}){
            commit('loadAllergies'); //loads list of allergy options
        },

        updateAllergies({commit},value) {
            commit('updateAllergies',value)
        },

        //-------------------------------------------------//
        //-----        food_type table actions        -----//
        //-------------------------------------------------//
        loadFoodTypes({commit}){
            commit('loadFoodTypes'); //loads list of food type options
        },

        updateFoodTypes({commit},value) {
            commit('updateFoodTypes',value)
        },

        //--------------------------------------------------//
        //-----     conversion_chart table actions     -----//
        //--------------------------------------------------//
        loadConversionChart({commit}){
            commit('loadConversionChart');
        },

        
//----------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- light green tables -------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------//
        //-------------------------------------------------//
        //-----         account table actions         -----//
        //-------------------------------------------------//
        async loadAccount({state},value) {                  //--------- I don't think this is used anymore, but left as example of async function
            let promise = new Promise((resolve) => {
                axios({
                    method: 'post',
                    url: state.url,
                    data: {
                        request: "get_account @email=\"" + value + "\""
                    }
                })
                .then(response => {
                    console.log('accountInfo:',response.data.body[0]);
                    state.account = response.data.body[0];
                    if(response.data.body[0].account_type == 'admin' | response.data.body[0].account_type == 'super admin'){
                        console.log('admin account detected');
                        state.adminView = true;
                    }
                    resolve(response.data.body[0].account_status)
                })
                .catch(error => {
                    console.log(error)
                })
            })
            let result = await promise;

            return result;
        },

        updateAccountStatus({commit},value) {
            commit('updateAccountStatus',value);
        },

        updateAccountAddress({commit},value){
            commit('updateAccountAddress',value);
        },

        //--------------------------------------------------//
        //-----        individual table actions        -----//
        //--------------------------------------------------//
        loadIndividuals({commit},value){
            commit('loadIndividuals',value);
        },

        addIndividual({state,commit},value) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "post_individual @email=\"" + state.user.attributes.email + "\""
                    + ", @name=\"" + value.name + "\""
                    + ", @gender=\"" + value.gender + "\""
                    + ", @birthYear=\"" + value.birth_year + "\""
                    + ", @weightLb=\"" + value.weight_lb + "\""
                    + ", @heightFt=\"" + value.height_ft + "\""
                    + ", @heightIn=\"" + value.height_in + "\""
                    + ", @activity=\"" + value.activity_level + "\""
                    + ", @goalWeight=\"" + value.goal_weight + "\""
                    + ", @dailyCalorieTarget=\"" + value.daily_calorie_target + "\""
                    + ", @suggestedCalories=\"" + value.suggested_calories + "\""
                }
            })
            .then(response => {
                console.log('addIndividual:',response);
                commit('loadIndividuals',state.user.attributes.email);
            })
            .catch(error => {
                console.log('addIndividual:',error)
            })
        },
        
        removeIndividual({state,commit},value) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "post_remove_individual @email=\"" + state.user.attributes.email + "\""
                    + ", @name=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('removeIndividual:',response);
                commit('loadIndividuals',state.user.attributes.email);
            })
            .catch(error => {
                console.log(error)
            })
    
            //commit('resetSuggestedCalories'); 
        },

        updateIndividual({state,commit},value) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "post_update_individual @email=\"" + state.user.attributes.email + "\""
                    + ", @name=\"" + value.name + "\""
                    + ", @gender=\"" + value.gender + "\""
                    + ", @birthYear=\"" + value.birth_year + "\""
                    + ", @weightLb=\"" + value.weight_lb + "\""
                    + ", @heightFt=\"" + value.height_ft + "\""
                    + ", @heightIn=\"" + value.height_in + "\""
                    + ", @activity=\"" + value.activity_level + "\""
                    + ", @goalWeight=\"" + value.goal_weight + "\""
                    + ", @dailyCalorieTarget=\"" + value.daily_calorie_target + "\""
                    + ", @suggestedCalories=\"" + value.suggested_calories + "\""
                }
            })
            .then(response => {
                console.log('updateIndividual:',response);
                commit('individualChangeMade',[value.index,false]);
                commit('loadIndividuals',state.user.attributes.email);
            })
            .catch(error => {
                console.log('updateIndividual:',error)
            })
            
            //commit('resetSuggestedCalories');

            // commit('updateIndividual',value);
        },

        individualChangeMade({state,commit},value) {
            commit('individualChangeMade',value);
            commit('suggestedCalories',[state.individual[value[0]],'existing',value[0]]);
        },

        //--------------------------------------------------//
        //----  account_allergy_junction table actions  ----//
        //--------------------------------------------------//
        loadAccountAllergyJunctions({commit},value){
            commit('loadAccountAllergyJunctions',value);
        },

        //-------------------------------------------------//
        //--- favorite_food_type_junction table actions ---//
        //-------------------------------------------------//
        loadFavoriteFoodTypeJunctions({commit},value){
            commit('loadFavoriteFoodTypeJunctions',value);
        },

        //-------------------------------------------------//
        //----  account_recipe_junction table actions  ----//
        //-------------------------------------------------//
        loadAccountRecipeJunctions({commit},value){
            commit('loadAccountRecipeJunctions',value);
        },

        //-------------------------------------------------//
        //-----        meal_time table actions        -----//
        //-------------------------------------------------//
        loadMealTimes({commit},value){
            commit('loadMealTimes',value);
        },

//---------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- blue tables ----------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//
        //--------------------------------------------------//
        //-----          recipe table actions          -----//
        //--------------------------------------------------//
        loadRecipes({commit}){
            commit('loadRecipes');
        },


        //-------------------------------------------------//
        //-----      recipe_source table actions      -----//
        //-------------------------------------------------//
        loadRecipeSources({commit}){
            commit('loadRecipeSources');
        },

        //-------------------------------------------------//
        //---  recipe_food_type_junction table actions  ---//
        //-------------------------------------------------//
        loadRecipeFoodTypeJunctions({commit}){
            commit('loadRecipeFoodTypeJunctions');
        },

        //--------------------------------------------------//
        //---  recipe_ingredient_junction table actions  ---//
        //--------------------------------------------------//
        loadRecipeIngredientJunctions({commit}){
            commit('loadRecipeIngredientJunctions');
        },

        //--------------------------------------------------//
        //-----        ingredient table actions        -----//
        //--------------------------------------------------//
        loadIngredients({commit}){
            commit('loadIngredients');
        },

        //--------------------------------------------------//
        //----   recipe_step_directions table actions   ----//
        //--------------------------------------------------//
        loadRecipeStepDirections({commit}){
            commit('loadRecipeStepDirections');
        },

        //--------------------------------------------------//
        //----    diet_recipe_junction table actions    ----//
        //--------------------------------------------------//
        loadDietRecipeJunctions({commit}){
            commit('loadDietRecipeJunctions');
        },
        
//---------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- dark green tables -------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//
        //--------------------------------------------------//
        //-----           menu table actions           -----//
        //--------------------------------------------------//
        generateMenu({commit},value) {
            commit('generateMenu',value);
        },

        loadMenus({commit},value){
            commit('loadMenus',value);
        },

        //--------------------------------------------------//
        //-- menu_recipe_meal_time_junction table actions --//
        //--------------------------------------------------//
        loadMenuRecipeMealTimeJunctions({commit},value){
            commit('loadMenuRecipeMealTimeJunctions',value);
        },

        //-------------------------------------------------//
        //-----      shopping_list table actions      -----//
        //-------------------------------------------------//
        loadShoppingLists({commit},value){
            commit('loadShoppingLists'),value;
        },

        //-------------------------------------------------//
        //-----      shopping_item table actions      -----//
        //-------------------------------------------------//
        loadShoppingItems({commit},value){
            commit('loadShoppingItems',value);
        },


//----------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- signup actions ---------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------//
        clearSignupData({commit}){
            commit('updateStepper',1);
            commit('updateMealsToPlan',null);
            commit('updatePeople',[]);
            commit('resetSuggestedCalories');
            commit('clearCredentials');
            commit('SUupdateDiet',null);
            commit('SUupdateAllergies',[]);
            commit('SUupdateLikes',[]);
        },
        updateStepper({commit},value){
            commit('updateStepper',value);
        },
        updateMealsToPlan({commit},value){
            commit('updateMealsToPlan',value);
        },
        addPeople({commit},value){
            commit('addPeople',value);
        },
        updatePeople({commit},value){
            commit('updatePeople',value);
        },
        removePeople({commit},value){
            commit('removePeople',value);
        },
        peopleChangeMade({commit},value){
            commit('suggestedCalories',value);
        },
        resetSuggestedCalories({commit}){
            commit('resetSuggestedCalories');
        },
        updateSuggestedCalories({commit},value) {
            commit('suggestedCalories',value);
        },
        suggestedCalories({commit},value){
            commit('suggestedCalories',value);
        },
        storeCredentials({commit},value){
            commit('storeCredentials',value);
        },
        clearCredentials({commit}){
            commit('clearCredentials');
        },
        createSQLAccount({commit,rootState}) {
            console.log("signup createSQLAccount action start");
            let url = rootState.data.url;
            commit('createSQLAccount',url);
        },
        SUupdateDiet({commit},value) {
            commit('SUupdateDiet',value);
        },
        SUupdateAllergies({commit},value) {
            commit('SUupdateAllergies',value);
        },
        SUupdateLikes({commit},value) {
            commit('SUupdateLikes',value);
        },
        updateNewPerson({commit},value) {
            commit('updateNewPerson',value);
        },

//----------------------------------------------------------------------------------------------------------------------//
//----------------------------------------------------- other data -----------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------//
        //--------------------------------------------------//
        //-----              save actions              -----//
        //--------------------------------------------------//
        saveNewIngredient({state,commit},value){

            //handle apostrophe
            let ingredientNameArray = value.name.split("");
            let ingredientNameLength = ingredientNameArray.length;
            let ingredientName = '';

            for (let i=0; i < ingredientNameLength; i++){
                if (ingredientNameArray[i] == "'") {
                    ingredientName += "''";
                } else if(!state.invalidChars.includes(ingredientNameArray[i])){
                    ingredientName += ingredientNameArray[i];
                }
            }

            //add new ingredient to store values for immediate use in recipe
            state.ingredient.push({
                name: value.name
                ,measurement_unit: value.measurementUnit
                ,unit_calories: (value.gramsTotalFat * 9 + value.gramsProtein * 4 + value.gramsTotalCarbohydrate * 4)
                ,unit_calories_from_fat: (value.gramsTotalFat * 9)
                ,unit_calories_from_carbohydrate: (value.gramsTotalCarbohydrate * 4)
                ,unit_calories_from_protein: (value.gramsProtein * 4)
                ,unit_grams_total_fat: value.gramsTotalFat
                ,unit_grams_saturated_fat: value.gramsSaturatedFat
                ,unit_grams_trans_fat: value.gramsTransFat
                ,unit_grams_polyunsaturated_fat: value.gramsPolyunsaturatedFat
                ,unit_grams_monounsaturated_fat: value.gramsMonounsaturatedFat
                ,unit_milligrams_cholesterol: value.milligramsCholesterol
                ,unit_milligrams_sodium: value.milligramsSodium
                ,unit_grams_total_carbohydrate: value.gramsTotalCarbohydrate
                ,unit_grams_dietary_fibers: value.gramsDietaryFiber
                ,unit_grams_sugars: value.gramsSugars
                ,unit_grams_protein: value.gramsProtein
                ,usage: 0
            });
            state.ingredientToAdd = value.name;
            let str = "";

            if (value.allergy.length > 0){
                str = ', @allergy="' + value.allergy + '"'
                console.log(', @allergy="' + value.allergy + '"',':',str);
            } 

            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                        "post_create_ingredient @name=\"" + ingredientName + "\""
                        + ", @plural=\"" + value.plural + "\""
                        + ", @storeSection=\"" + value.storeSection + "\""
                        + ", @measurementUnit=\"" + value.measurementUnit + "\""
                        + ", @gramsProtein=\"" + value.gramsProtein + "\""
                        + ", @gramsTotalFat=\"" + value.gramsTotalFat + "\""
                        + ", @gramsSaturatedFat=\"" + value.gramsSaturatedFat + "\""
                        + ", @gramsMonounsaturatedFat=\"" + value.gramsMonounsaturatedFat + "\""
                        + ", @gramsPolyunsaturatedFat=\"" + value.gramsPolyunsaturatedFat + "\""
                        + ", @gramsTransFat=\"" + value.gramsTransFat + "\""
                        + ", @gramsTotalCarbohydrate=\"" + value.gramsTotalCarbohydrate + "\""
                        + ", @gramsSugars=\"" + value.gramsSugars + "\""
                        + ", @gramsDietaryFibers=\"" + value.gramsDietaryFiber + "\""
                        + ", @milligramsCholesterol=\"" + value.milligramsCholesterol + "\""
                        + ", @milligramsSodium=\"" + value.milligramsSodium + "\""
                        + str
                }
            })
            .then(response => {
                console.log('saveNewIngredient:',response);
                
                // update recipes length and close dialog window
                state.createNewIngredientDialog = false;
                state.selectedIngredientId = null;
                state.processing = false;

                if(value.route == 'ingredients'){
                    // clear values to re-load
                    state.ingredient = [];
                    state.ingredientsToAvoidJunction = [];
                }
 
                 // re-load values
                 commit('loadIngredients');
                 commit('loadIngredientsToAvoidJunctions');
            })
            .catch(error => {
                console.log('saveNewIngredient:',error);
            });
        },

        editExistingIngredient({state,commit},value){
            let ingredientNameArray = value.name.split("");
            let ingredientNameLength = ingredientNameArray.length;
            let ingredientName = '';

            for (let i=0; i < ingredientNameLength; i++){
                if (ingredientNameArray[i] == "'") {
                    ingredientName += "''";
                } else if(!state.invalidChars.includes(ingredientNameArray[i])){
                    ingredientName += ingredientNameArray[i];
                }
            }

            let str = "";

            if (value.allergy.length > 0){
                str = ', @allergy="' + value.allergy + '"'
                console.log(', @allergy="' + value.allergy + '"',':',str);
            } 

            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                        "post_edit_ingredient @id=\"" + value.id + "\""
                        + ", @name=\"" + ingredientName + "\""
                        + ", @plural=\"" + value.plural + "\""
                        + ", @storeSection=\"" + value.storeSection + "\""
                        + ", @measurementUnit=\"" + value.measurementUnit + "\""
                        + ", @gramsProtein=\"" + value.gramsProtein + "\""
                        + ", @gramsTotalFat=\"" + value.gramsTotalFat + "\""
                        + ", @gramsSaturatedFat=\"" + value.gramsSaturatedFat + "\""
                        + ", @gramsMonounsaturatedFat=\"" + value.gramsMonounsaturatedFat + "\""
                        + ", @gramsPolyunsaturatedFat=\"" + value.gramsPolyunsaturatedFat + "\""
                        + ", @gramsTransFat=\"" + value.gramsTransFat + "\""
                        + ", @gramsTotalCarbohydrate=\"" + value.gramsTotalCarbohydrate + "\""
                        + ", @gramsSugars=\"" + value.gramsSugars + "\""
                        + ", @gramsDietaryFibers=\"" + value.gramsDietaryFiber + "\""
                        + ", @milligramsCholesterol=\"" + value.milligramsCholesterol + "\""
                        + ", @milligramsSodium=\"" + value.milligramsSodium + "\""
                        + ", @audit=\"" + value.audited + "\""
                        + str
                }
            })
            .then(response => {
                console.log('saveEditIngredient:',response);

                // clear values to re-load
                state.ingredient = [];
                state.ingredientsToAvoidJunction = [];

                // update recipes length and close dialog window
                state.createNewIngredientDialog = false;
                state.selectedIngredientId = null;
                state.processing = false;

                // re-load values
                commit('loadIngredients');
                commit('loadIngredientsToAvoidJunctions');
            })
            .catch(error => {
                console.log('saveEditIngredient:',error);
            });
        },

        deleteIngredient({state,commit},value){
            state.deleteIngredientErrorMessage = null;

            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                        "post_delete_ingredient @id=\"" + value + "\""
                }
            })
            .then(response => {
                if (response.data.body[0].success == 'true') {
                    // clear values to re-load
                    state.ingredient = [];
                    state.ingredientsToAvoidJunction = [];
                    state.deleteIngredientDialog = false;
                    state.editIngredientDialog = false;
                    state.selectedIngredientId = null;
    
                    // update recipes length and close dialog window
                    state.selectedIngredientId = null;
                    state.processing = false;
    
                    // re-load values
                    commit('loadIngredients');
                    commit('loadIngredientsToAvoidJunctions');
                } else {
                    state.deleteIngredientErrorMessage = response.data.body[0].payload;
                }
            })
            .catch(error => {
                console.log('deleteIngredient:',error);
            });
        },
        
        saveNewRecipe({state,commit},value){

            // start ingredients
            let ingredientList = '';
            let ingredientPreparation = [];
            let ingredientPreparationLength = '';
            let ingredientPreparationEntry = '';
            let ingredientsLength = state.ingredients.length;

            let ingredientNameArray = [];
            let ingredientNameLength = '';
            let ingredientNameEntry = '';

            for (let i=0; i < ingredientsLength; i++){
                ingredientNameEntry = '';

                if (state.ingredients[i].preparation != null){
                    ingredientPreparationEntry = '';
                    ingredientPreparation = state.ingredients[i].preparation.split("");
                    ingredientPreparationLength = ingredientPreparation.length;
    
                    for (let j=0; j < ingredientPreparationLength; j++){
                        if (ingredientPreparation[j] == "'") {
                            ingredientPreparationEntry += "''";
                        } else if(!state.invalidChars.includes(ingredientPreparation[j])){
                            ingredientPreparationEntry += ingredientPreparation[j];
                        }
                    }
                } else {
                    ingredientPreparationEntry = null;
                }
                

                ingredientNameArray = state.ingredients[i].name.split("");
                ingredientNameLength = ingredientNameArray.length;

                for (let j=0; j < ingredientNameLength; j++){
                    if (ingredientNameArray[j] == "'") {
                        ingredientNameEntry += "''";
                    } else if(!state.invalidChars.includes(ingredientNameArray[j])){
                        ingredientNameEntry += ingredientNameArray[j];
                    }
                }

                
                ingredientList += '['
                ingredientList += ingredientNameEntry
                ingredientList += '|'
                ingredientList += state.ingredients[i].amount
                ingredientList += '|'
                ingredientList += state.ingredients[i].unit
                ingredientList += '|'
                ingredientList += state.ingredients[i].displayUnit
                ingredientList += '|'
                ingredientList += ingredientPreparationEntry
            }
            // console.log('ingredientList:',ingredientList);

            // start directions
            let directionsList = '';
            let direction = [];
            let directionLength = 0;
            let directionEntry = '';
            let directionsLength = state.directions.length;

            for (let i=0; i < directionsLength; i++){
                directionEntry = "";
                direction = state.directions[i].directions.split("");
                directionLength = direction.length;

                for (let j=0; j < directionLength; j++){
                    if(direction[j] == "'") {
                        directionEntry += "''";
                    } else if(!state.invalidChars.includes(direction[j])){
                        directionEntry += direction[j];
                    }
                }

                directionsList += '['
                directionsList += state.directions[i].number
                directionsList += '|'
                directionsList += directionEntry
            }
            // console.log('directionsList:',directionsList);


            // start recipe name (to handle apostrophe)
            let recipeNameArray = value[0].name.split("");
            let recipeNameLength = recipeNameArray.length;
            let recipeName = '';

            for (let i=0; i < recipeNameLength; i++){
                if (recipeNameArray[i] == "'") {
                    recipeName += "''";
                } else if(!state.invalidChars.includes(recipeNameArray[i])){
                    recipeName += recipeNameArray[i];
                }
            }
            //console.log('recipeName',recipeName);

            // start source name (to handle apostrophe)
            let sourceArray = value[1].sourceName.split("");
            let sourceLength = sourceArray.length;
            let sourceName = '';
 
            for (let i=0; i < sourceLength; i++){
                if (sourceArray[i] == "'") {
                    sourceName += "''";
                } else if(!state.invalidChars.includes(sourceArray[i])){
                    sourceName += sourceArray[i];
                }
            }
            //console.log('sourceName:', sourceName);     
            
            // start author (to handle apostrophe)
            let author = '';

            if (value[1].author != null){
                let authorArray = value[1].author.split("");
                let authorLength = sourceArray.length;
     
                for (let i=0; i < authorLength; i++){
                    if (authorArray[i] == "'") {
                        author += "''";
                    } else if(!state.invalidChars.includes(authorArray[i])){
                        author += authorArray[i];
                    }
                }
                //console.log('author:', author); 
            }

            if (author == ''){
                author = null;
            }
            
            //if recipe source is missing, add it as an option to the recipe sources in the store
            if(value[1].recipeSource == 'Other') {
                let url = null;
                let author = null;

                if (value[1].url !== 'undefined'){
                    url = value[1].url
                }
                if (value[1].author !== 'undefined'){
                    author = value[1].author
                }
                
                state.recipeSource.push({
                    type: value[1].type,
                    source_name: value[1].sourceName,
                    url: url,
                    author: author
                })
            }

            // start photo credit (to handle apostrophe)
            let photoCreditArray = value[0].photoCredit.split("");
            let photoCreditLength = photoCreditArray.length;
            let photoCredit = '';

            for (let i=0; i < photoCreditLength; i++){
                if (photoCreditArray[i] == "'") {
                    photoCredit += "''";
                } else if(!state.invalidChars.includes(photoCreditArray[i])){
                    photoCredit += photoCreditArray[i];
                }
            }

            // start short recipe name (for image name)
            let shortRecipeName = '';
            let array = state.recipeName.toLowerCase().split("");
            let arrayLength = array.length;

            for (let i=0; i < arrayLength; i++) {
                if (state.validLowerChars.includes(array[i])) {
                    shortRecipeName += array[i];
                }
            }
            
            let photoURL = 'https://sfp-recipe-photos.s3-us-west-2.amazonaws.com/images/' + shortRecipeName + '.' + state.fileType;
            
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                        "post_create_recipe @recipeSource='" + value[1].recipeSource + "'"
                        + ", @type='" + value[1].type + "'"
                        + ", @sourceName='" + sourceName + "'"
                        + ", @url='" + value[1].url + "'"
                        + ", @author='" + author + "'"
                        + ", @name='" + recipeName + "'"
                        + ", @photoURL='" + photoURL + "'"
                        + ", @photoCredit='" + photoCredit + "'"
                        + ", @recipeSourceLookupName='" + sourceName + "'"
                        + ", @recipeSourceURL='" + value[0].recipeSourceURL + "'"
                        + ", @mealType='" + value[0].mealType + "'"
                        + ", @leftoverTypes='" + value[0].leftoverTypes + "'"
                        + ", @difficulty='" + value[0].difficulty + "'"
                        + ", @prepTimeMin='" + value[0].prepTimeMin + "'"
                        + ", @foodTypes='" + value[0].foodType + "'"
                        + ", @ingredients='" + ingredientList + "'"
                        + ", @directions='" + directionsList + "'"
                }
            })
            .then(response => {
                console.log('saveNewRecipe:',response);
                
                // clear values to re-load
                state.recipe = [];
                state.ingredient = [];
                state.recipeIngredientJunction = [];
                state.dietRecipeJunction = [];
                state.recipeFoodTypeJunction = [];
                state.recipeStepDirections = [];

                // update recipes length and close dialog window
                state.addRecipeDialog = false;

                // re-load values
                commit('loadRecipes');
                commit('loadIngredients');
                commit('loadRecipeIngredientJunctions');
                commit('loadDietRecipeJunctions');
                commit('loadRecipeFoodTypeJunctions');
                commit('loadRecipeStepDirections');

                // turn off processing spinner on recipes list (data loading spinner will resolve what's needed)
                state.processing = false;
            })
            .catch(error => {
                console.log('saveNewRecipe:',error);
            });

        },

        editExistingRecipe({state,commit},value){

            // start ingredients
            let ingredientList = '';
            let ingredientPreparation = [];
            let ingredientPreparationLength = '';
            let ingredientPreparationEntry = '';
            let ingredientsLength = state.ingredients.length;

            let ingredientNameArray = [];
            let ingredientNameLength = '';
            let ingredientNameEntry = '';

            for (let i=0; i < ingredientsLength; i++){
                ingredientNameEntry = '';

                if (state.ingredients[i].preparation != null){
                    ingredientPreparationEntry = '';
                    ingredientPreparation = state.ingredients[i].preparation.split("");
                    ingredientPreparationLength = ingredientPreparation.length;
    
                    for (let j=0; j < ingredientPreparationLength; j++){
                        if (ingredientPreparation[j] == "'") {
                            ingredientPreparationEntry += "''";
                        } else if(!state.invalidChars.includes(ingredientPreparation[j])){
                            ingredientPreparationEntry += ingredientPreparation[j];
                        }
                    }
                } else {
                    ingredientPreparationEntry = null;
                }
                

                ingredientNameArray = state.ingredients[i].name.split("");
                ingredientNameLength = ingredientNameArray.length;

                for (let j=0; j < ingredientNameLength; j++){
                    if (ingredientNameArray[j] == "'") {
                        ingredientNameEntry += "''";
                    } else if(!state.invalidChars.includes(ingredientNameArray[j])){
                        ingredientNameEntry += ingredientNameArray[j];
                    }
                }

                
                ingredientList += '['
                ingredientList += ingredientNameEntry
                ingredientList += '|'
                ingredientList += state.ingredients[i].amount
                ingredientList += '|'
                ingredientList += state.ingredients[i].unit
                ingredientList += '|'
                ingredientList += state.ingredients[i].displayUnit
                ingredientList += '|'
                ingredientList += ingredientPreparationEntry
            }
            // console.log('ingredientList:',ingredientList);

            // start directions
            let directionsList = '';
            let direction = [];
            let directionLength = 0;
            let directionEntry = '';
            let directionsLength = state.directions.length;

            for (let i=0; i < directionsLength; i++){
                directionEntry = "";
                direction = state.directions[i].directions.split("");
                directionLength = direction.length;

                for (let j=0; j < directionLength; j++){
                    if(direction[j] == "'") {
                        directionEntry += "''";
                    } else if(!state.invalidChars.includes(direction[j])){
                        directionEntry += direction[j];
                    }
                }

                directionsList += '['
                directionsList += state.directions[i].number
                directionsList += '|'
                directionsList += directionEntry
            }
            // console.log('directionsList:',directionsList);

            // start recipe name (to handle apostrophe)
            let recipeNameArray = value[0].name.split("");
            let recipeNameLength = recipeNameArray.length;
            let recipeName = '';

            for (let i=0; i < recipeNameLength; i++){
                if (recipeNameArray[i] == "'") {
                    recipeName += "''";
                } else if(!state.invalidChars.includes(recipeNameArray[i])){
                    recipeName += recipeNameArray[i];
                }
            }
            //console.log('recipeName',recipeName);
 
            // start source name (to handle apostrophe)
            let sourceArray = value[1].sourceName.split("");
            let sourceLength = sourceArray.length;
            let sourceName = '';
 
            for (let i=0; i < sourceLength; i++){
                if (sourceArray[i] == "'") {
                    sourceName += "''";
                } else if(!state.invalidChars.includes(sourceArray[i])){
                    sourceName += sourceArray[i];
                }
            }
            //console.log('sourceName:', sourceName);

            // start author (to handle apostrophe)
            let author = '';

            if (value[1].author != null){
                let authorArray = value[1].author.split("");
                let authorLength = sourceArray.length;
     
                for (let i=0; i < authorLength; i++){
                    if (authorArray[i] == "'") {
                        author += "''";
                    } else if(!state.invalidChars.includes(authorArray[i])){
                        author += authorArray[i];
                    }
                }
                //console.log('author:', author); 
            }

            //if recipe source is missing, add it as an option to the recipe sources in the store
            if(value[1].recipeSource == 'Other') {
                let url = null;
                let author = null;

                if (value[1].url !== 'undefined'){
                    url = value[1].url
                }
                if (value[1].author !== 'undefined'){
                    author = value[1].author
                }
                
                state.recipeSource.push({
                    type: value[1].type,
                    source_name: value[1].sourceName,
                    url: url,
                    author: author
                })
            }

            // start photo credit (to handle apostrophe)
            let photoCreditArray = value[0].photoCredit.split("");
            let photoCreditLength = photoCreditArray.length;
            let photoCredit = '';

            for (let i=0; i < photoCreditLength; i++){
                if (photoCreditArray[i] == "'") {
                    photoCredit += "''";
                } else if(!state.invalidChars.includes(photoCreditArray[i])){
                    photoCredit += photoCreditArray[i];
                }
            }

            // start short recipe name (for image name)
            let shortRecipeName = '';
            let array = state.recipeName.toLowerCase().split("");
            let arrayLength = array.length;

            for (let i=0; i < arrayLength; i++) {
                if (state.validLowerChars.includes(array[i])) {
                    shortRecipeName += array[i];
                }
            }

            let photoURL = state.thisRecipe.photo_url;
            if(state.fileType != null){
                photoURL = 'https://sfp-recipe-photos.s3-us-west-2.amazonaws.com/images/' + shortRecipeName + '.' + state.fileType;
            }


            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                        "post_edit_recipe @rid='" + value[0].id + "'"
                        + ", @recipeSource='" + value[1].recipeSource + "'"
                        + ", @type='" + value[1].type + "'"
                        + ", @sourceName='" + sourceName + "'"
                        + ", @url='" + value[1].url + "'"
                        + ", @author='" + author + "'"
                        + ", @name='" + recipeName + "'"
                        + ", @photoURL='" + photoURL + "'"
                        + ", @photoCredit='" + photoCredit + "'"
                        + ", @recipeSourceLookupName='" + sourceName + "'"
                        + ", @recipeSourceURL='" + value[0].recipeSourceURL + "'"
                        + ", @mealType='" + value[0].mealType + "'"
                        + ", @leftoverTypes='" + value[0].leftoverTypes + "'"
                        + ", @difficulty='" + value[0].difficulty + "'"
                        + ", @prepTimeMin='" + value[0].prepTimeMin + "'"
                        + ", @foodTypes='" + value[0].foodType + "'"
                        + ", @ingredients='" + ingredientList + "'"
                        + ", @directions='" + directionsList + "'"
                        + ", @audit='" + value[0].audited + "'"
                }
            })
            .then(response => {
                console.log('editExistingRecipe:',response);
                
                // clear values to re-load
                state.recipe = [];
                state.ingredient = [];
                state.recipeIngredientJunction = [];
                state.dietRecipeJunction = [];
                state.recipeFoodTypeJunction = [];
                state.recipeStepDirections = [];

                // update recipes length and close dialog window
                state.editRecipe = false;
                state.recipeDialog = false;

                // re-load values
                commit('loadRecipes');
                commit('loadIngredients');
                commit('loadRecipeIngredientJunctions');
                commit('loadDietRecipeJunctions');
                commit('loadRecipeFoodTypeJunctions');
                commit('loadRecipeStepDirections');

                // turn off processing spinner on recipes list (data loading spinner will resolve what's needed)
                state.processing = false;
            })
            .catch(error => {
                console.log('editExistingRecipe:',error);
            });

        },

        uploadPhoto({commit},value){
            commit('uploadPhoto',value);
        },
        
        //---------------------------------------------------//
        //-----              other actions              -----//
        //---------------------------------------------------//
        updateNavMenu({commit},value){
            commit('updateNavMenu',value);
        },
        updateIngredientToAdd({commit},value){
            commit('updateIngredientToAdd',value);
        },
        updateIngredients({commit},value){
            commit('updateIngredients',value);
        },
        updateCreateNewIngredientDialog({commit},value){
            commit('updateCreateNewIngredientDialog',value);
        },
        updateDirections({commit},value){
            commit('updateDirections',value)
        },
        updateRecipeName({commit},value){
            commit('updateRecipeName',value);
        },
        updateFileType({commit},value){
            commit('updateFileType',value);
        },
        updateSelectedRecipeID({commit},value){
            commit('updateSelectedRecipeID',value);
        },
        resizeWindow({commit}){
            commit('resizeWindow');
        },
        updateAddRecipeDialog({commit},value){
            commit('updateAddRecipeDialog',value);
        },
        forceRerender({commit},value){
            commit('forceRerender',value);
        },
        updateRecipeDialog({commit},value){
            commit('updateRecipeDialog',value);
        },
        savedPreferences({commit}){
            commit('savedPreferences');
        },
        loadPreferences({state,commit}){
            commit('updateDiets','reset');
            commit('updateAllergies','reset');
            commit('updateFoodTypes','reset');
            state.savedPreferences = true;
        },
        updateMealTimeToEdit({commit},value){
            commit('updateMealTimeToEdit',value);
        },
        updateEditMealDialog({commit},value){
            commit('updateEditMealDialog',value);
        },
        deleteRecipe({state,commit},value){
            axios({
                method: 'post',

                url: state.url,
                data: {
                    request:
                        "delete_recipe @rid=\"" + value + "\""
                        + ", @aid=\"" + state.account.id + "\""
                        + ", @src=\"online\""
                }
            })
            .then(response => {
                console.log('deleteRecipe:',response);

                // clear values to re-load
                state.recipe = [];
                state.ingredient = [];
                state.recipeIngredientJunction = [];
                // state.dietRecipeJunction = [];
                // state.recipeFoodTypeJunction = [];
                // state.recipeStepDirections = [];

                // re-load values
                commit('loadRecipes');
                commit('loadIngredients');
                commit('loadRecipeIngredientJunctions');
                // commit('loadDietRecipeJunctions');
                // commit('loadRecipeFoodTypeJunctions');
                // commit('loadRecipeStepDirections');

            })
            .catch(error => {
                console.log('deleteRecipe:',error);
            });
        },
        updateEditRecipe({commit},value){
            commit('updateEditRecipe',value);
        },
        updateThisRecipeSource({commit},value){
            commit('updateThisRecipeSource',value);
        },
        updatePhotoCredit({commit},value){
            commit('updatePhotoCredit',value);
        },
        updateDifficulty({commit},value){
            commit('updateDifficulty',value);
        },
        updatePrepTimeMin({commit},value){
            commit('updatePrepTimeMin',value);
        },
        updateMealType({commit},value){
            commit('updateMealType',value);
        },
        updateLeftoverType({commit},value){
            commit('updateLeftoverType',value);
        },
        updateFoodType({commit},value){
            commit('updateFoodType',value);
        },
        updateDirectRecipeURL({commit},value){
            commit('updateDirectRecipeURL',value);
        },
        updateAudited({commit},value){
            commit('updateAudited',value);
        },
        updateAdminView({commit},value){
            commit('updateAdminView',value);
        },
        updateAddIngredientDialog({commit},value){
            commit('updateAddIngredientDialog',value);
        },
        updateSelectedIngredientId({commit},value){
            commit('updateSelectedIngredientId',value);
        },
        updateEditIngredientDialog({commit},value){
            commit('updateEditIngredientDialog',value);
        },
        updateNewIngredientName({commit},value){
            commit('updateNewIngredientName',value);
        },
        updateNewIngredientPlural({commit},value){
            commit('updateNewIngredientPlural',value);
        },
        updateNewIngredientUnitQuantity({commit},value){
            commit('updateNewIngredientUnitQuantity',value);
        },
        updateStoreSection({commit},value){
            commit('updateStoreSection',value);
        },
        updateNewIngredientUnit({commit},value){
            commit('updateNewIngredientUnit',value);
        },
        updateNewIngredientAllergy({commit},value){
            commit('updateNewIngredientAllergy',value);
        },
        updateNutrition({commit},value){
            commit('updateNutrition',value);
        },
        updateDeleteIngredientDialog({commit},value){
            commit('updateDeleteIngredientDialog',value);
        }
        

    },

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    mutations: {
//---------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- system data ----------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//
        updateUser(state,value) {
            state.user = value;
        },

        clearUser(state) {
            state.user = [];
        },

        session(state,value) {
            state.session = value;
        },

        clearSession(state) {
            state.session = [];
        },

        updateProcessing(state,value) {
            state.processing = value;
        },

        loadUser(state) {
            //first refresh cognito user information
            Auth.currentAuthenticatedUser()
            .then(user => {
                console.log('loadUser:',user);
                state.user = user;
                
                // //refresh SQL account data
                // axios({
                //     method: 'post',
                //     url: state.url,
                //     data: {
                //         request: "get_account @email=\"" + state.user.attributes.email + "\""
                //     }
                // })
                // .then(response => {
                //     console.log('loadUser/account:',response.data.body[0]);
                //     state.account = response.data.body[0];
                // })
                // .catch(error => {
                //     console.log('loadUser/account:',error)
                // })
            })
            .catch(error => {
                console.log('loadUser:',error);
            });
        },

//---------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- purple tables ---------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//

        //--------------------------------------------------//
        //-----          diet table mutations          -----//
        //--------------------------------------------------//
        loadDiets(state) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_diets"
                }
            })
            .then(response => {
                console.log('loadDiets:',response);
                state.diets = response.data.body;
            })
            .catch(error => {
                console.log('loadDiets:',error)
            })
        },
        
        //records which diet has been selected locally, still need to save changes to SQL
        updateDiets(state,value) {
            let max = state.diets.length

            if(value == 'reset') {
                for (let i = 0; i < max; i++) {
                    if(state.diets[i].id == state.account.diet_lookup) {
                        state.diets[i].selected = true;
                    } else {
                        state.diets[i].selected = false;
                    }
                }
            } else {
                for (let i = 0; i < max; i++) {
                    state.diets[i].selected = false;
                }
                state.diets[value].selected = true;
            }
        },

        clearDiets(state) {
            state.diets = [];
        },

        //-------------------------------------------------//
        //-----        allergy table mutations        -----//
        //-------------------------------------------------//
        loadAllergies(state) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_allergies"
                }
            })
            .then(response => {
                console.log('loadAllergies:',response);
                state.allergies = response.data.body;
            })
            .catch(error => {
                console.log('loadAllergies:',error)
            })
        },

        //records which allergies have been selected locally, still need to save changes to SQL
        updateAllergies(state,value) {
            let maxA = state.allergies.length
            let maxB = state.accountAllergyJunctions.length

            if (value == 'reset') {
                for (let i=0; i < maxA; i++){
                    for (let j=0; j < maxB; j++){
                        if(state.allergies[i].id == state.accountAllergyJunctions[j].allergy_lookup){
                            state.allergies[i].selected = true;
                            j = maxB;
                        } else {
                            state.allergies[i].selected = false;
                        }
                    }
                }
            } else {
                if(state.allergies[value].selected == 'false' | state.allergies[value].selected == false) {
                    state.allergies[value].selected = true;
                } else {
                    state.allergies[value].selected = false;
                }
            }
        },

        clearAllergies(state) {
            state.allergies = [];
        },

        //-------------------------------------------------//
        //-----       food_type table mutations       -----//
        //-------------------------------------------------//
        loadFoodTypes(state) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_food_types"
                }
            })
            .then(response => {
                console.log('loadFoodTypes:',response);
                state.foodTypes = response.data.body;
            })
            .catch(error => {
                console.log('loadFoodTypes:',error)
            })
        },
        
        //records which food types have been selected locally, still need to save changes to SQL
        updateFoodTypes(state,value) {
            let maxA = state.foodTypes.length;
            let maxB = state.favoriteFoodTypeJunction.length;

            if (value == 'reset') {
                for (let i=0; i < maxA; i++){
                    for (let j=0; j < maxB; j++){
                        if(state.foodTypes[i].id == state.favoriteFoodTypeJunction[j].food_type_lookup){
                            state.foodTypes[i].selected = true;
                            j = maxB;
                        } else {
                            state.foodTypes[i].selected = false;
                        }
                    }
                }
            } else {
                if(state.foodTypes[value].selected == 'false' | state.foodTypes[value].selected == false) {
                    state.foodTypes[value].selected = true
                } else {
                    state.foodTypes[value].selected = false
                }
            }
        },

        clearFoodTypes(state) {
            state.foodTypes = [];
        },

        //-------------------------------------------------//
        //--ingredients_to_avoid_junction table mutations--//
        //-------------------------------------------------//
        loadIngredientsToAvoidJunctions(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_ingredients_to_avoid_junctions @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadIngredientsToAvoidJunctions:',response);
                state.ingredientsToAvoidJunction = response.data.body;
            })
            .catch(error => {
                console.log('loadIngredientsToAvoidJunctions:',error)
            })
        },

        clearIngredientsToAvoidJunction(state) {
            state.ingredientsToAvoidJunction = [];
        },

        //--------------------------------------------------//
        //-----    conversion_chart table mutations    -----//
        //--------------------------------------------------//
        loadConversionChart(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_conversion_chart"
                }
            })
            .then(response => {
                console.log('loadConversionChart:',response);
                state.conversionChart = response.data.body;
            })
            .catch(error => {
                console.log('loadConversionChart:',error);
            });
        },

        clearConversionChart(state) {
            state.conversionChart = [];
        },



//----------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- light green tables -------------------------------------------------//
//----------------------------------------------------------------------------------------------------------------------//

        //-------------------------------------------------//
        //-----        account table mutations        -----//
        //-------------------------------------------------//
        loadAccount(state,value) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_account @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadAccount:',response.data.body[0]);
                state.account = response.data.body[0];
                if(response.data.body[0].account_type == 'admin' || response.data.body[0].account_type == 'super admin'){
                    console.log('admin account detected');
                    state.adminView = true;
                }
            })
            .catch(error => {
                console.log('loadAccount:',error)
            })
        },

        updateAccountStatus(state,value) {
            //update SQL table
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "post_account_status_update @email=\"" + state.user.attributes.email + "\""
                    + ", @account_status=\"" + value + "\""
                }
            })
            .then(response => {
                console.log(response);
                state.account.account_status = value; //update the local value to match what was just put into SQL
            })
            .catch(error => {
                console.log(error);
            });

            //update Cognito table
            Auth.currentAuthenticatedUser()
            .then(user => {
                Auth.updateUserAttributes(user, 
                    {
                        'custom:status': value
                    }
                ).then(
                    data => {
                        console.log('updateAccountStatus:',data);
                        state.user.attributes['custom:status'] = value; //update the local value to match what was just put into cognito
                    }
                ).catch(
                    error => {
                        console.log('updateAccountStatus:',error);
                    }
                );
            })
            .catch(error => {
                console.log(error);
            });

            
        },
        
        updateAccountAddress(state,value) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "post_account_address_update @email=\"" + state.user.attributes.email + "\""
                    + ", @street_address=\"" + value[0] + "\""
                    + ", @city=\"" + value[1] + "\""
                    + ", @state=\"" + value[2] + "\""
                    + ", @zip=\"" + value[3] + "\""
                }
            })
            .then(response => {
                console.log('updateAccountAddress:',response);
            })
            .catch(error => {
                console.log('updateAccountAddress:',error);
            })
        },
        
        clearAccount(state) {
            state.account = [];
        },

        //--------------------------------------------------//
        //-----       individual table mutations       -----//
        //--------------------------------------------------//
        loadIndividuals(state,value) {
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_individuals @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadIndividuals:',response);
                state.individual = response.data.body;
            })
            .catch(error => {
                console.log('loadIndividuals:',error)
            })
        },
        
        //re-write/cleanup
        // removeremoveIndividual({state,commit},value) {
        //     axios({
        //         method: 'post',
        //         url: state.url,
        //         data: {
        //             request:
        //             "post_remove_individual @email=\"" + state.user.attributes.email + "\""
        //             + ", @name=\"" + value + "\""
        //         }
        //     })
        //     .then(response => {
        //         console.log('removeIndividual:',response);
        //         commit('loadIndividuals',state.user.attributes.email);
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
  
        //     //commit('resetSuggestedCalories');
        // },

        clearIndividual(state) {
            state.individual = [];
        },

        //re-write/cleanup
        // updateIndividual({state,commit},value) {
        //     axios({
        //         method: 'post',
        //         url: state.url,
        //         data: {
        //             request:
        //             "post_update_individual @email=\"" + state.user.attributes.email + "\""
        //             + ", @name=\"" + value[0] + "\""
        //             + ", @gender=\"" + value[1] + "\""
        //             + ", @birthYear=\"" + value[2] + "\""
        //             + ", @weight=\"" + value[3] + "\""
        //             + ", @height=\"" + value[4] + "\""
        //             + ", @activity=\"" + value[5] + "\""
        //             + ", @goal=\"" + value[6] + "\""
        //             + ", @dailyCalorieTarget=\"" + value[7] + "\""
        //             + ", @suggestedCalories=\"" + value[8] + "\""
        //         }
        //     })
        //     .then(response => {
        //         console.log('updateIndividual:',response);
        //         commit('loadIndividuals',state.user.attributes.email);
        //     })
        //     .catch(error => {
        //         console.log('updateIndividual:',error)
        //     })
            
        //     //commit('resetSuggestedCalories');
        // },
    
        individualChangeMade(state,value) {
            state.individual[value[0]].needToSave = value[1];
        },
  

        //--------------------------------------------------//
        //---- account_allergy_junction table mutations ----//
        //--------------------------------------------------//
        loadAccountAllergyJunctions(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_account_allergy_junctions @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadAccountAllergyJunctions:',response);
                state.accountAllergyJunctions = response.data.body;
            })
            .catch(error => {
                console.log('loadAccountAllergyJunctions:',error)
            })
        },

        clearAccountAllergyJunctions(state) {
            state.accountAllergyJunctions = [];
        },

        //-------------------------------------------------//
        //-- favorite_food_type_junction table mutations --//
        //-------------------------------------------------//
        loadFavoriteFoodTypeJunctions(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_account_favorite_food_type_junctions @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadFavoriteFoodTypeJunctions:',response);
                state.favoriteFoodTypeJunction = response.data.body;
            })
            .catch(error => {
                console.log('loadFavoriteFoodTypeJunctions:',error)
            })
        },

        clearFavoriteFoodTypeJunction(state) {
            state.favoriteFoodTypeJunction = [];
        },

        //-------------------------------------------------//
        //---- account_recipe_junction table mutations ----//
        //-------------------------------------------------//
        loadAccountRecipeJunctions(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_account_recipe_junctions @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadAccountRecipeJunctions:',response);
                state.accountRecipeJunction = response.data.body;
            })
            .catch(error => {
                console.log('loadAccountRecipeJunctions:',error)
            })
        },

        clearAccountRecipeJunction(state) {
            state.accountRecipeJunction = [];
        },

        //-------------------------------------------------//
        //-----       meal_time table mutations       -----//
        //-------------------------------------------------//
        loadMealTimes(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                    "get_meal_times @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadMealTimes:',response);
                state.mealTime = response.data.body;
            })
            .catch(error => {
                console.log('loadMealTimes:',error)
            })
        },

        clearMealTime(state) {
            state.mealTime = [];
        },


//---------------------------------------------------------------------------------------------------------------------//
//---------------------------------------------------- blue tables ----------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//

        //--------------------------------------------------//
        //-----         recipe table mutations         -----//
        //--------------------------------------------------//
        loadRecipes(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_recipes"
                }
            })
            .then(response => {
                console.log('loadRecipes:',response);
                state.recipe = response.data.body;
            })
            .catch(error => {
                console.log('loadRecipes:',error);
            });
        },

        clearRecipe(state) {
            state.recipe = [];
        },

        //-------------------------------------------------//
        //-----     recipe_source table mutations     -----//
        //-------------------------------------------------//
        loadRecipeSources(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_recipe_sources"
                }
            })
            .then(response => {
                console.log('loadRecipeSources:',response);
                state.recipeSource = response.data.body;
            })
            .catch(error => {
                console.log('loadRecipeSources:',error);
            });
        },

        clearRecipeSource(state) {
            state.recipeSource = [];
        },

        //-------------------------------------------------//
        //--- recipe_food_type_junction table mutations ---//
        //-------------------------------------------------//
        loadRecipeFoodTypeJunctions(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_recipe_food_type_junctions"
                }
            })
            .then(response => {
                console.log('loadRecipeFoodTypeJunctions:',response);
                state.recipeFoodTypeJunction = response.data.body;
            })
            .catch(error => {
                console.log('loadRecipeFoodTypeJunctions:',error);
            });
        },

        clearRecipeFoodTypeJunction(state) {
            state.recipeFoodTypeJunction = [];
        },

        //--------------------------------------------------//
        //--- recipe_ingredient_junction table mutations ---//
        //--------------------------------------------------//
        loadRecipeIngredientJunctions(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_recipe_ingredient_junctions"
                }
            })
            .then(response => {
                console.log('loadRecipeIngredientJunctions:',response);
                state.recipeIngredientJunction = response.data.body;
            })
            .catch(error => {
                console.log('loadRecipeIngredientJunctions:',error);
            });
        },

        clearRecipeIngredientJunction(state) {
            state.recipeIngredientJunction = [];
        },

        //--------------------------------------------------//
        //-----       ingredient table mutations       -----//
        //--------------------------------------------------//
        loadIngredients(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_ingredient_options"
                }
            })
            .then(response => {
                console.log('loadIngredients:',response);
                state.ingredient = response.data.body;
            })
            .catch(error => {
                console.log('loadIngredients:',error);
            });
        },

        clearIngredient(state) {
            state.ingredient = [];
        },

        //--------------------------------------------------//
        //----  recipe_step_directions table mutations  ----//
        //--------------------------------------------------//
        loadRecipeStepDirections(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_recipe_step_directions"
                }
            })
            .then(response => {
                console.log('loadRecipeStepDirections:',response);
                state.recipeStepDirections = response.data.body;
            })
            .catch(error => {
                console.log('loadRecipeStepDirections:',error);
            });
        },

        clearRecipeStepDirections(state) {
            state.recipeStepDirections = [];
        },

        //--------------------------------------------------//
        //----  recipe_step_directions table mutations  ----//
        //--------------------------------------------------//
        loadDietRecipeJunctions(state){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_diet_recipe_junctions"
                }
            })
            .then(response => {
                console.log('loadDietRecipeJunctions:',response);
                state.dietRecipeJunction = response.data.body;
            })
            .catch(error => {
                console.log('loadDietRecipeJunctions:',error);
            });
        },

        clearDietRecipeJunction(state) {
            state.dietRecipeJunction = [];
        },
        
//---------------------------------------------------------------------------------------------------------------------//
//------------------------------------------------- dark green tables -------------------------------------------------//
//---------------------------------------------------------------------------------------------------------------------//

        //--------------------------------------------------//
        //-----          menu table mutations          -----//
        //--------------------------------------------------//
        generateMenu(state,value) {
            console.log("generateMenu method start");
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request:
                        "post_create_menu @email=\"" + state.user.attributes.email + "\""
                        + ", @menuStartDate=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('generateMenu:',response);
            })
            .catch(error => {
                console.log('generateMenu:',error);
            })
        },

        loadMenus(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_menus @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadMenus:',response);
                state.menu = response.data.body;
            })
            .catch(error => {
                console.log('loadMenus:',error);
            });
        },

        clearMenu(state) {
            state.menu = [];
        },

        //--------------------------------------------------//
        //- menu_recipe_meal_time_junction table mutations -//
        //--------------------------------------------------//
        loadMenuRecipeMealTimeJunctions(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_menu_recipe_meal_time_junctions @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadMenuRecipeMealTimeJunctions:',response);
                state.menuRecipeMealTimeJunction = response.data.body;
            })
            .catch(error => {
                console.log('loadMenuRecipeMealTimeJunctions:',error);
            });
        },

        clearMenuRecipeMealTimeJunction(state) {
            state.menuRecipeMealTimeJunction = [];
        },

        //-------------------------------------------------//
        //-----     shopping_list table mutations     -----//
        //-------------------------------------------------//
        loadShoppingLists(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_shopping_lists @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadShoppingLists:',response);
                state.shoppingList = response.data.body;
            })
            .catch(error => {
                console.log('loadShoppingLists:',error);
            });
        },

        clearShoppingList(state) {
            state.shoppingList = [];
        },

        //-------------------------------------------------//
        //-----     shopping_item table mutations     -----//
        //-------------------------------------------------//
        loadShoppingItems(state,value){
            axios({
                method: 'post',
                url: state.url,
                data: {
                    request: "get_shopping_items @email=\"" + value + "\""
                }
            })
            .then(response => {
                console.log('loadShoppingItems:',response);
                state.shoppingItem = response.data.body;
            })
            .catch(error => {
                console.log('loadShoppingItems:',error);
            });
        },

        clearShoppingItem(state) {
            state.shoppingItem = [];
        },


//------------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- signup mutations ---------------------------------------------------//
//------------------------------------------------------------------------------------------------------------------------//
        updateStepper(state,value){
            state.stepper = value;
        },
        updateMealsToPlan(state,value){
            state.mealsToPlan = value;
        },
        addPeople(state,value){
            state.people.push(value);
        },
        updatePeople(state,value){
            state.people[value[0]] = value[1];
        },
        removePeople(state,value){
            state.people.splice(value,1);
        },
        resetSuggestedCalories(state){
            state.suggestedCalories = null;  
        },
        suggestedCalories(state,value) {
            // console.log('-----------------------------');
            // console.log('suggestedCalories input:',value);
            // console.log('-----------------------------');
  
            let response = null;
            let gender = null;
            let birthYear = null;
            let weight = null;
            let height = null;
            let activityLevel = null;
            let goalWeight = null;
            let goalWeightAdjustment = null;
              
            if (value[1] == 'new'){
                if (value[2].gender == 'Male' | value[2].gender == 'M') {
                    gender = 'M'
                } else if (value[2].gender == 'Female' | value[2].gender == 'F') {
                    gender = 'F'
                }
                birthYear = parseInt(value[2].birthYear);
                weight = parseInt(value[2].weight);
                height = (parseInt(value[2].heightFt) * 12) + parseInt(value[2].heightIn);
                activityLevel = value[2].activityLevel;
                goalWeight = parseInt(value[2].goalWeight);
                goalWeightAdjustment = Math.max(Math.min(((goalWeight - weight)/13)*500,500),-500)               
            } else if (value[1] == 'update'){
                if (state.people[value[0]].gender == 'Male' | state.people[value[0]].gender == 'M') {
                    gender = 'M'
                } else if (state.people[value[0]].gender == 'Female' | state.people[value[0]].gender == 'F') {
                    gender = 'F'
                }
                birthYear = state.people[value[0]].birth_year;
                weight = state.people[value[0]].weight_lb;
                height = (parseInt(state.people[value[0]].height_ft) * 12) + parseInt(state.people[value[0]].height_in);
                activityLevel = state.people[value[0]].activity_level;
                goalWeight = state.people[value[0]].goal_weight;
                goalWeightAdjustment = Math.max(Math.min(((goalWeight - weight)/13)*500,500),-500)
            } else if (value[1] == 'existing'){
                if (value[0].gender == 'Male' | value[0].gender == 'M') {
                    gender = 'M'
                } else if (value[0].gender == 'Female' | value[0].gender == 'F') {
                    gender = 'F'
                }
                birthYear = value[0].birth_year;
                weight = value[0].weight_lb;
                height = (parseInt(value[0].height_ft) * 12) + parseInt(value[0].height_in);
                activityLevel = value[0].activity_level;
                goalWeight = value[0].weight_goal;
                goalWeightAdjustment = Math.max(Math.min(((goalWeight - weight)/13)*500,500),-500)
            }
            
            let age = (new Date().getFullYear() - birthYear);

            // CONSOLE LOGS FOR DEBUGGING
            // console.log('-----------------------------');
            // console.log('gender:', gender);
            // console.log('age:', age);
            // console.log('weight',weight);
            // console.log('height',height);
            // console.log('activityLevel',activityLevel);
            // console.log('goalWeight',goalWeight);
            // console.log('goalWeightAdjustment',goalWeightAdjustment);
            // console.log('-----------------------------');
              
            if(age >= 16){
                if(
                    gender != null &&
                    birthYear != null &&
                    weight != null &&
                    height != null &&
                    activityLevel != null &&
                    goalWeight != null
                ){
                    response = (
                        weight * 4.531393
                        + height * 15.875
                        - age * 4.92
                    );
        
                    if(gender == "F") {
                        response -= 161
                    } else {
                        response += 5}
                  
                    if(activityLevel == 'sedentary') {
                        response *= 1.2
                    } else if (activityLevel == 'light') {
                        response *= 1.375
                    } else if (activityLevel == 'active') {
                        response *= 1.55
                    } else if (activityLevel == 'very active') {
                        response *= 1.725
                    }

                    response += goalWeightAdjustment;
                            
                    response = Math.round(response);
  
                }
            } else if(age == 2) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1000
                    } else if (activityLevel == 'bery active') {
                        response = 1000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1000
                    } else if (activityLevel == 'very active') {
                        response = 1000
                    }
                }
        
            } else if (age == 3) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1400
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1000
                    } else if (activityLevel == 'active') {
                        response = 1200
                    } else if (activityLevel == 'very active') {
                        response = 1400
                    }
                }
        
            } else if (age == 4) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1400
                    }
                }
        
            } else if (age == 5) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                }
        
            } else if (age == 6) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1400
                    } else if (activityLevel == 'very active') {
                        response = 1600
                    }
                }
        
            } else if (age == 7) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1200
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                }
        
            } else if (age == 8) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                }
        
            } else if (age == 9) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1600
                    } else if (activityLevel == 'very active') {
                        response = 1800
                    }
                }
        
            } else if (age == 10) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1400
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                }
        
            } else if (age == 11) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 1800
                    } else if (activityLevel == 'very active') {
                        response = 2000
                    }
                }
        
            } else if (age == 12) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2200
                    } else if (activityLevel == 'very active') {
                        response = 2400
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                }
        
            } else if (age == 13) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 2000
                    } else if (activityLevel == 'active') {
                        response = 2200
                    } else if (activityLevel == 'very active') {
                        response = 2600
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1600
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2200
                    }
                }
        
            } else if (age == 14) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 2000
                    } else if (activityLevel == 'active') {
                        return 2400
                    } else if (activityLevel == 'very active') {
                        response = 2800
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2400
                    }
                }
                
            } else if (age == 15) {
                if(gender == 'M') {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 2200
                    } else if (activityLevel == 'active') {
                        response = 2600
                    } else if (activityLevel == 'very active') {
                        response = 3000
                    }
                } else {
                    if(activityLevel == 'sedentary' || activityLevel == 'light') {
                        response = 1800
                    } else if (activityLevel == 'active') {
                        response = 2000
                    } else if (activityLevel == 'very active') {
                        response = 2400
                    }
                }
            }
              
            // console.log('suggested calories response:',response);
            if (value[1] == 'update') {
                state.people[value[0]].suggested_calories = response;
            } else if (value[1] == 'new') {
                state.suggestedCalories = response;
            } else if (value[1] == 'existing'){
                state.individual[value[2]].suggested_calories = response;
            }
        },
        storeCredentials(state,value){
            state.credentials = value;
        },
        clearCredentials(state){
            state.credentials = [];
        },
        createSQLAccount(state,url) {
            let peopleList = '';
            for (let i = 0; i < state.people.length; i++){
                peopleList += '['
                peopleList += state.people[i].name
                peopleList += ','
                peopleList += state.people[i].gender
                peopleList += ','
                peopleList += state.people[i].birth_year
                peopleList += ','
                peopleList += state.people[i].weight_lb
                peopleList += ','
                peopleList += state.people[i].height_ft
                peopleList += ','
                peopleList += state.people[i].height_in
                peopleList += ','
                peopleList += state.people[i].activity_level
                peopleList += ','
                peopleList += state.people[i].goal_weight
                peopleList += ','
                peopleList += state.people[i].daily_calorie_target
                peopleList += ','
                peopleList += state.people[i].suggested_calories
            }

            axios({
                method: 'post',
                url: url,
                data: {
                    request:
                        "create_account @email='" + state.credentials[0] + "'"
                        + ", @diet='" + state.SUdiet + "'"
                        + ", @allergy='" + state.SUallergies + "'"
                        + ", @like='" + state.SUlikes + "'"
                        + ", @mealsToPlan='" + state.mealsToPlan + "'"
                        + ", @people='" + peopleList + "'"
                }
            })
            .then(response => {
                console.log(response);
            })
            .catch(error => {
                console.log(error);
            })
        },
        SUupdateDiet(state,value) {
            state.SUdiet = value;
        },
        SUupdateAllergies(state,value) {
            if (value.includes('none',0) & value != 'none') {
                state.SUallergies = ['none'];
            } else {
                state.SUallergies = value;
            }
        },
        SUupdateLikes(state,value) {
            state.SUlikes = value;
        },
        updateNewPerson(state,value) {
            state.newPerson = value;
        },


//-----------------------------------------------------------------------------------------------------------------------//
//--------------------------------------------------- other functions ---------------------------------------------------//
//-----------------------------------------------------------------------------------------------------------------------//

        //--------------------------------------------------//
        //-----             save mutations             -----//
        //--------------------------------------------------//
        uploadPhoto(state,value){
            let shortRecipeName = '';
            let array = state.recipeName.toLowerCase().split("");

            for (let i=0; i < array.length; i++) {
                if (state.validLowerChars.includes(array[i])) {
                    shortRecipeName += array[i];
                }
            }

            axios({
                method: 'post',
                url: state.uploadPhotoURL,
                data: {
                    imageData: value,
                    recipe: shortRecipeName,
                    fileType: state.fileType
                },
            })
            .then(response => {
                console.log('uploadPhoto:',response);
            })
            .catch(error => {
                console.log('uploadPhoto:',error);
            });
        },

        //---------------------------------------------------//
        //-----             other mutations             -----//
        //---------------------------------------------------//
        updateNavMenu(state,value){
            state.navMenu = value;
        },
        updateIngredientToAdd(state,value){
            state.ingredientToAdd = value;
        },
        updateIngredients(state,value){
            state.ingredients = value;
        },
        updateCreateNewIngredientDialog(state,value){
            state.createNewIngredientDialog = value;
        },
        updateDirections(state,value){
            state.directions = value;
        },
        updateRecipeName(state,value){
            state.recipeName = value;
        },
        updateFileType(state,value){
            state.fileType = value;
        },
        updateSelectedRecipeID(state,value){
            state.selectedRecipeID = value;

            if (value != null){
                let max = state.recipe.length;
                for (let i=0; i < max; i++) {
                    if (state.recipe[i].id == state.selectedRecipeID) {
                        state.thisRecipe = state.recipe[i];
                        i=max;
                    }
                }
            }

            
        },
        resizeWindow(state){
            // console.log('height',window.innerHeight);
            // console.log('width',window.innerWidth);
            state.windowHeight = window.innerHeight;
            state.windowWidth = window.innerWidth
        },
        updateAddRecipeDialog(state,value){
            state.addRecipeDialog = value;
        },
        forceRerender(state,value){
            state.rerender = value;
        },
        updateRecipeDialog(state,value){
            state.recipeDialog = value;
        },
        savedPreferences(state) {
            let noChange = true
            let maxD = state.diets.length
            let maxA = state.allergies.length
            let maxAA = state.accountAllergyJunctions.length
            let maxF = state.foodTypes.length
            let maxFF = state.favoriteFoodTypeJunction.length
            
            //check if selected diet matches SQL selected diet
            for (let i = 0; i < maxD; i++) {
                if(state.diets[i].id == state.account.diet_lookup) {
                    if (state.diets[i].selected == true) {
                        i = maxD;
                        noChange = true;
                    } else {
                        noChange = false;
                    }
                }
            }

            //check if selected allergies matches SQL selected allergies
            for (let i=0; i < maxA; i++){
                if (noChange == true) {
                    for (let j=0; j < maxAA; j++){
                        //this if will catch when an allergy is selected locally and in SQL
                        if(state.allergies[i].selected == true && state.allergies[i].id == state.accountAllergyJunctions[j].allergy_lookup){
                            noChange = true;
                            j = maxAA;
                        //this if will catch when an allergy is selected locally but this junction isn't a match (set noChange to false, but don't end the looping)
                        } else if (state.allergies[i].selected == true && state.allergies[i].id != state.accountAllergyJunctions[j].allergy_lookup){
                            noChange = false;
                        //this if will catch when an allergy is NOT selected locally but it is selected in SQL
                        } else if (state.allergies[i].selected == false && state.allergies[i].id == state.accountAllergyJunctions[j].allergy_lookup){
                            noChange = false;
                            j = maxAA;
                        }
                    }
                } else {
                    i = maxA;
                }
            }

            //check if selected favorite food types matches SQL selected favorite food types
            for (let i=0; i < maxF; i++){
                if (noChange == true) {
                    for (let j=0; j < maxFF; j++){
                        //this if will catch when a food type is selected locally and in SQL
                        if(state.foodTypes[i].selected == true && state.foodTypes[i].id == state.favoriteFoodTypeJunction[j].food_type_lookup){
                            noChange = true;
                            j = maxFF;
                        //this if will catch when a food type is selected locally but this junction isn't a match (set noChange to false, but don't end the looping)
                        } else if (state.foodTypes[i].selected == true && state.foodTypes[i].id != state.favoriteFoodTypeJunction[j].food_type_lookup){
                            noChange = false;
                        //this if will catch when a food type is NOT selected locally but it is selected in SQL
                        } else if (state.foodTypes[i].selected == false && state.foodTypes[i].id == state.favoriteFoodTypeJunction[j].food_type_lookup) {
                            noChange = false;
                            j = maxFF;
                        }
                    }
                } else {
                    i = maxF;
                }
            }

            if(noChange == true) {
                state.savedPreferences = true
            } else {
                state.savedPreferences = false
            }
        },
        updateMealTimeToEdit(state,value){
            state.mealTimeToEdit = value;
        },
        updateEditMealDialog(state,value){
            state.editMealDialog = value;
        },
        updateEditRecipe(state,value){
            state.editRecipe = value;

            //whether opening or closing the edit dialog, clear out stored values
            state.recipeName = null;
            state.thisRecipeSource = null;
            state.directRecipeURL = null;
            state.selectedRecipeImageURL = null;
            state.photoCredit = null;
            state.difficulty = null;
            state.prepTimeMin = null;
            state.mealType = [];
            state.leftoverType = [];
            state.foodType = [];
            state.ingredients = [];
            state.directions = [];
            state.audited = null;

            //if edit dialog is opening, update stored values
            if (value == true) {

                let selectedRecipe = [];
                let Rmax = state.recipe.length;
                let Smax = state.recipeSource.length;
                let Jmax = state.recipeIngredientJunction.length;
                let Fmax = state.recipeFoodTypeJunction.length;
                let Imax = state.ingredient.length;
                let Dmax = state.recipeStepDirections.length;


                for(let i=0; i < Rmax; i++){
                    if(state.recipe[i].id == state.selectedRecipeID){
                        selectedRecipe = state.recipe[i];
                        state.recipeName = selectedRecipe.name;
                        i = Rmax;
                    }
                }

                for(let j=0; j < Smax; j++){
                    if(state.recipeSource[j].id == selectedRecipe.recipe_source_lookup){
                        state.thisRecipeSource = state.recipeSource[j].source_name;
                        j = Smax;
                    }
                }

                state.directRecipeURL = selectedRecipe.recipe_source_url;
                state.selectedRecipeImageURL = selectedRecipe.photo_url;
                state.photoCredit = selectedRecipe.photo_credit;
                state.difficulty = selectedRecipe.difficulty;
                state.prepTimeMin = selectedRecipe.prep_time_min;
                state.mealType = selectedRecipe.meal_type.split(',');
                state.leftoverType = selectedRecipe.leftover_types.split(',');

                for(let k=0; k < Fmax; k++){
                    if(state.recipeFoodTypeJunction[k].recipe_lookup == selectedRecipe.id){
                        state.foodType.push(state.recipeFoodTypeJunction[k].food_type_lookup);
                    }
                }
                
                for(let l=0; l < Jmax; l++){
                    if(state.recipeIngredientJunction[l].recipe_lookup == selectedRecipe.id){
                        for(let m=0; m < Imax; m++){
                            if(state.ingredient[m].id == state.recipeIngredientJunction[l].ingredient_lookup){
                                state.ingredients.push({
                                    name: state.ingredient[m].name,
                                    plural: state.ingredient[m].plural,
                                    amount: state.recipeIngredientJunction[l].quantity,
                                    unit: state.recipeIngredientJunction[l].unit,
                                    displayUnit: state.recipeIngredientJunction[l].display_unit,
                                    preparation: state.recipeIngredientJunction[l].preparation,
                                });
                            }
                        }
                    }
                }

                for(let n=0; n < Dmax; n++){
                    if(state.recipeStepDirections[n].recipe_lookup == selectedRecipe.id){
                        state.directions.push({
                            number: state.recipeStepDirections[n].step_number,
                            directions: state.recipeStepDirections[n].directions,
                        });
                    }
                }
                
                state.directions = state.directions.sort((a,b) => (a.step_number > b.step_number) ? -1 : 1);
                
                if(selectedRecipe.audited == null){
                    state.audited = false;
                } else {
                    state.audited = true
                }
            }
        },
        updateThisRecipeSource(state,value){
            state.thisRecipeSource = value;
        },
        updatePhotoCredit(state,value){
            state.photoCredit = value;
        },
        updateDifficulty(state,value){
            state.difficulty = value;
        },
        updatePrepTimeMin(state,value){
            state.prepTimeMin = value;
        },
        updateMealType(state,value){
            state.mealType = value;
        },
        updateLeftoverType(state,value){
            state.leftoverType = value;
        },
        updateFoodType(state,value){
            state.foodType = value;
        },
        updateDirectRecipeURL(state,value){
            state.directRecipeURL = value;
        },
        updateAudited(state,value){
            state.audited = value;
        },
        updateAdminView(state,value){
            state.adminView = value;
            state.rerender += 1;
        },
        updateAddIngredientDialog(state,value){
            state.addIngredientDialog = value;
        },
        updateSelectedIngredientId(state,value){
            state.selectedIngredientId = value;
            state.deleteIngredientErrorMessage = null;

            if(value == null) {
                state.selectedIngredient = [];
                state.newIngredientName = null
                state.newIngredientPlural = null;
                state.storeSection = null;
                state.newIngredientUnitQuantity = null;
                state.newIngredientUnit = null;
                state.newIngredientAllergy = [];
                state.editIngredientDialog = false;
                state.audited = null;

                let max = state.nutrition.length;
                for (let n=0; n < max; n++){
                    state.nutrition[n].amount = null;
                }

                
            } else {
                let max = state.ingredient.length;
    
                for (let i=0; i < max; i++) {
                    if (state.ingredient[i].id == state.selectedIngredientId) {
                        state.selectedIngredient = state.ingredient[i];
                        i = max;
                    }
                }

                state.newIngredientName = state.selectedIngredient.name;
                state.newIngredientPlural = state.selectedIngredient.plural;
                state.storeSection = state.selectedIngredient.grocery_store_section;
                state.newIngredientUnitQuantity = 1;
                state.newIngredientUnit = state.selectedIngredient.measurement_unit;

                state.newIngredientAllergy = [];

                let max2 = state.ingredientsToAvoidJunction.length;

                for (let j=0; j < max2; j++){
                    if(state.ingredientsToAvoidJunction[j].ingredient_lookup == state.selectedIngredient.id){
                        state.newIngredientAllergy.push(state.ingredientsToAvoidJunction[j].allergy_lookup)
                    }
                }

                state.nutrition[0].amount = state.selectedIngredient.unit_grams_total_fat;
                state.nutrition[1].amount = state.selectedIngredient.unit_grams_saturated_fat;
                state.nutrition[2].amount = state.selectedIngredient.unit_grams_trans_fat;
                state.nutrition[3].amount = state.selectedIngredient.unit_grams_polyunsaturated_fat;
                state.nutrition[4].amount = state.selectedIngredient.unit_grams_monounsaturated_fat;
                state.nutrition[5].amount = state.selectedIngredient.unit_milligrams_cholesterol;
                state.nutrition[6].amount = state.selectedIngredient.unit_milligrams_sodium;
                state.nutrition[7].amount = state.selectedIngredient.unit_grams_total_carbohydrate;
                state.nutrition[8].amount = state.selectedIngredient.unit_grams_dietary_fibers;
                state.nutrition[9].amount = state.selectedIngredient.unit_grams_sugars;
                state.nutrition[10].amount = state.selectedIngredient.unit_grams_protein;

                if(state.selectedIngredient.audited == null){
                    state.audited = false;
                } else {
                    state.audited = true;
                }

            }
        },
        updateEditIngredientDialog(state,value){
            state.editIngredientDialog = value;
        },
        updateNewIngredientName(state,value){
            state.newIngredientName = value;
        },
        updateNewIngredientPlural(state,value){
            state.newIngredientPlural = value;
        },
        updateNewIngredientUnitQuantity(state,value){
            state.newIngredientUnitQuantity = value;
        },
        updateStoreSection(state,value){
            state.storeSection = value;
        },
        updateNewIngredientUnit(state,value){
            state.newIngredientUnit = value;
        },
        updateNewIngredientAllergy(state,value){
            state.newIngredientAllergy = value;
        },
        updateNutrition(state,value){
            state.nutrition = value;
        },
        updateDeleteIngredientDialog(state,value){
            state.deleteIngredientDialog = value;
        }

    },


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    getters: {
        //-----         system data         -----//
        user(state){
            return state.user;
        },
        session(state){
            return state.session;
        },
        processing(state){
            return state.processing;
        },

        //-----        purple tables        -----//
        diets(state){
            return state.diets;
        },
        allergies(state){
            return state.allergies;
        },
        foodTypes(state){
            return state.foodTypes;
        },
        ingredientsToAvoidJunction(state){
            return state.ingredientsToAvoidJunction;
        },
        conversionChart(state){
            return state.conversionChart;
        },

        //-----      light green tables      -----//
        account(state){
            return state.account;
        },
        individual(state){
            return state.individual;
        },
        accountAllergyJunctions(state){
            return state.accountAllergyJunctions;
        },
        favoriteFoodTypeJunction(state){
            return state.favoriteFoodTypeJunction;
        },
        accountRecipeJunction(state){
            return state.accountRecipeJunction;
        },
        mealTime(state){
            return state.mealTime;
        },

        //-----         blue tables         -----//
        recipe(state){
            return state.recipe;
        },
        recipeSource(state){
            return state.recipeSource;
        },
        recipeFoodTypeJunction(state){
            return state.recipeFoodTypeJunction;
        },
        recipeIngredientJunction(state){
            return state.recipeIngredientJunction;
        },
        ingredient(state){
            return state.ingredient;
        },

        // ingredient(state){
        //     if (state.adminView) {
        //         let result = state.ingredient;
        
        //         let rijLength = state.recipeIngredientJunction.length;
        //         let ingredientsLength = result.length;
        //         let count = 0;
        
        //         for (let i=0; i < ingredientsLength; i++){
        //             for (let j=0; j < rijLength; j++){
        //                 if (result[i].id == state.recipeIngredientJunction[j].ingredient_lookup){
        //                     count += 1;
        //                 }
        //             }
        //             result[i].usage = count;
        //             count = 0;
        
        //             if (result[i].audited == null){
        //                 result[i].auditedDate = null;
        //             } else {
        //                 result[i].auditedDate = moment(result[i].audited).format('M/D/YYYY')
        //             }
        //         }
        
        //         return result;
        //     } else {
        //         return state.ingredient;
        //     }
        // },

        recipeStepDirections(state){
            return state.recipeStepDirections;
        },
        dietRecipeJunction(state){
            return state.dietRecipeJunction;
        },
        
        //-----      dark green tables      -----//
        menu(state){
            return state.menu;
        },
        menuRecipeMealTimeJunction(state){
            return state.menuRecipeMealTimeJunction;
        },
        shoppingList(state){
            return state.shoppingList;
        },
        shoppingItem(state){
            return state.shoppingItem;
        },     
        
        //-----         signup data         -----//
        stepper(state){
            return state.stepper;
        },
        mealsToPlan(state){
            return state.mealsToPlan;
        },
        people(state){
            return state.people;
        },
        suggestedCalories(state){
            return state.suggestedCalories;
        },
        credentials(state){
            return state.credentials;
        },
        SUdiet(state){
            return state.SUdiet;
        },
        SUallergies(state){
            return state.SUallergies;
        },
        SUlikes(state) {
            return state.SUlikes;
        },
        newPerson(state) {
            return state.newPerson;
        },
        
        //-----        other values        -----//
        navMenu(state){
            return state.navMenu;
        },
        ingredientToAdd(state){
            return state.ingredientToAdd;
        },
        ingredients(state){
            return state.ingredients;
        },
        createNewIngredientDialog(state){
            return state.createNewIngredientDialog;
        },
        directions(state){
            return state.directions;
        },
        recipeName(state){
            return state.recipeName
        },
        fileType(state){
            return state.fileType;
        },
        selectedRecipeID(state){
            return state.selectedRecipeID;
        },
        dataLoaded(state){
            if(
                //-----        purple tables        -----//
                state.diets.length == 0 |
                state.allergies.length == 0 |
                state.foodTypes.length == 0 |
                state.ingredientsToAvoidJunction.length == 0 |
                state.conversionChart.length == 0 |

            //-----      light green tables      -----//
                state.account.id == null |
                state.individual.length == 0 |
                //state.accountAllergyJunctions.length == 0 |           //could be blank
                state.favoriteFoodTypeJunction.length == 0 |
                state.accountRecipeJunction.length == 0 |
                state.mealTime.length == 0 |

            //-----         blue tables         -----//
                state.recipe.length == 0 |
                state.recipeSource.length == 0 |
                state.recipeFoodTypeJunction.length == 0 |
                state.recipeIngredientJunction.length == 0 |
                state.ingredient.length == 0 |
                state.recipeStepDirections.length == 0 |
                state.dietRecipeJunction.length == 0

            //-----      dark green tables      -----//
                //state.menu.length == 0 |                              //could be blank
                //state.menuRecipeMealTimeJunction.length == 0 |        //could be blank
                //state.shoppingList.length == 0 |                      //could be blank
                //state.shoppingItem.length == 0                        //could be blank
            ) {
                state.dataLoaded = false;
                return false
            } else {
                if (state.dataLoaded == false) {
                    state.dataLastRefreshed = new Date;
                }
                state.dataLoaded = true;
                return true
            }
        },
        windowHeight(state){
            return state.windowHeight;
        },
        windowWidth(state){
            return state.windowWidth;
        },
        addRecipeDialog(state){
            return state.addRecipeDialog;
        },
        rerender(state){
            return state.rerender;
        },
        recipeDialog(state){
            return state.recipeDialog;
        },
        savedPreferences(state){
            return state.savedPreferences
        },
        mealTimeToEdit(state){
            return state.mealTimeToEdit;
        },
        editMealDialog(state){
            return state.editMealDialog;
        },
        editRecipe(state){
            return state.editRecipe;
        },
        thisRecipeSource(state){
            return state.thisRecipeSource;
        },
        photoCredit(state){
            return state.photoCredit;
        },
        difficulty(state){
            return state.difficulty;
        },
        prepTimeMin(state){
            return state.prepTimeMin;
        },
        mealType(state){
            return state.mealType;
        },
        leftoverType(state){
            return state.leftoverType;
        },
        foodType(state){
            return state.foodType;
        },
        selectedRecipeImageURL(state){
            return state.selectedRecipeImageURL;
        },
        thisRecipe(state){
            return state.thisRecipe;
        },
        directRecipeURL(state){
            return state.directRecipeURL;
        },
        audited(state){
            return state.audited;
        },
        adminView(state){
            return state.adminView;
        },
        addIngredientDialog(state){
            return state.addIngredientDialog;
        },
        selectedIngredientId(state){
            return state.selectedIngredientId;
        },
        editIngredientDialog(state){
            return state.editIngredientDialog;
        },
        newIngredientName(state){
            return state.newIngredientName;
        },
        newIngredientPlural(state){
            return state.newIngredientPlural;
        },
        newIngredientUnitQuantity(state){
            return state.newIngredientUnitQuantity;
        },
        storeSection(state){
            return state.storeSection;
        },
        newIngredientUnit(state){
            return state.newIngredientUnit;
        },
        newIngredientAllergy(state){
            return state.newIngredientAllergy;
        },
        nutrition(state){
            return state.nutrition;
        },
        deleteIngredientErrorMessage(state){
            return state.deleteIngredientErrorMessage;
        },
        deleteIngredientDialog(state){
            return state.deleteIngredientDialog;
        },
        selectedIngredient(state){
            return state.selectedIngredient;
        }


    }
}
